<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item">
                <router-link to="/groups">{{ $t('exchange_rate') }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">{{$t('exchange_rate_create')}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="clickSaveHandler"><i class="fa fa-floppy-o"></i> {{$t('save')}}</button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div v-if="$v.$error" class="alert alert-danger x-error">
                        <div class="error" v-if="!$v.date.required">- សូមជ្រើរើសកាលបរិច្ចេទ</div>
                        <div class="error" v-if="!$v.model.Value.required">- សូមធ្វើកាបញ្ចូលតម្លៃ</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group" :class="{ 'form-group-error': $v.date.$error }">
                                <label class="label-control blue">{{$t('date')}}</label>
                                <input type="date" class="form-control form-control-sm" v-model="$v.date.$model"/>
                            </div>
                            <div class="form-group">
                                <label class="label-control blue">{{$t('to_date')}}</label>
                                <input type="date" class="form-control form-control-sm" v-model="toDate"/>
                            </div>
                            <div class="form-group" :class="{'form-group-error': $v.model.Value.$error}">
                                <label class="label-control blue">{{$t('currency_value')}} <span class="text-danger">*</span></label>
                                <input type="text" class="form-control form-control-sm" v-model="$v.model.Value.$model">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
        import { required } from 'vuelidate/lib/validators';
        import moment from 'moment';
        export default {
            data: function(){
                return {
                    model: {
                        Date: "",
                        CurrencyCode: "Riel",
                        Value: ""
                    },
                    date: this.$now().format('YYYY-MM-DD'),
                    toDate: this.$now().format('YYYY-MM-DD'),
                }
            },
            created(){
                let id = this.$route.params.id;
                if(id != undefined){
                    this.findById(id);
                }
            },
            validations:{
                model: {
                    Value: {required}
                },
                date: { required }
            },
            methods: {
                findById: function(id){
                    this.$api().post('exchangerate/find', { Id: id }).then(res => {
                        if(this.$isValid(res)){
                            this.model = res.data.Json.ExchangeRate;
                            this.data = this.$format(this.model.Date).format('YYYY-MM-DD');
                            this.toDate = this.$format(this.model.Date).format('YYYY-MM-DD');
                        }
                    });
                },
                clickSaveHandler: function(){
                    this.$v.$touch();
                    if(!this.$v.$invalid) {
                        var loading = this.$loading.show();
                        this.model.Date = this.date;
                        let req = [];
                        let onDate = moment(this.data);
                        let toDate = moment(this.toDate);
                        do{
                            req.push({
                                Date: onDate.format('YYYY-MM-DD'),
                                CurrencyCode: "Riel",
                                Value: this.model.Value
                            });
                            onDate = onDate.add(1, 'days');
                        }while(onDate < toDate);
                        this.$api().post('exchangerate/save', req).then(res => {
                            if (this.$isValid(res)) {
                                this.$router.push('/exchangerates');
                            }
                        }).finally(function(){ loading.hide(); });
                    }
                }
            }
    }
</script>